import React, { useState } from 'react';
import { AppCard, AppModal, AppRemixIcon } from '@/layout/AppComponents';
import styled from 'styled-components';
import ReactDOMServer from 'react-dom/server';
import EvidenceNewForm from '../../ExpandedTabs/Evidence/EvidenceNewForm';
import colors from '../../../../../../../constants/colors';
import Translator from '../../../../../../components/helpers/Translator';

const ChangeBlockEvidence = (props) => {
  const { handleAddEvidence, value } = props;
  const [showNewEvidenceModal, setShowNewEvidenceModal] = useState(false);
  return (
    <>
      <span
        className={`btn btn-block btn-sm btn-outline-light mb-2 ${value === null ? '' : 'disabled'}`}
        onClick={() => (value === null ? setShowNewEvidenceModal(true) : undefined)}
      >
        <Translator file="module-legalCompliance" name="create.evidence" />
      </span>
      {value === null
        ? <small><Translator file="module-legalCompliance" name="create.evidence.mode.selected.obligations" /></small>
        : (
          <AppCard>
            <EvidenceElement>
              <span>{value.name}</span>
              <AppRemixIcon
                icon="delete-bin"
                color={colors.danger}
                onClick={() => handleAddEvidence(null)}
                title={ReactDOMServer.renderToString(<Translator file="user" name="user.remove" />)}
                className="pointer"
              />
            </EvidenceElement>

          </AppCard>
        )}

      <AppModal
        show={showNewEvidenceModal}
        title={ReactDOMServer.renderToString(<Translator file="module-legalCompliance" name="create.evidence.template" />)}
        onClose={() => setShowNewEvidenceModal(false)}
        size="lg"
      >
        <EvidenceNewForm
          handleAddEvidence={(v) => { handleAddEvidence(v); setShowNewEvidenceModal(false); }}
        />
      </AppModal>
    </>
  );
};
export default ChangeBlockEvidence;

const EvidenceElement = styled.div`
  display: grid;
  grid-template-columns: 1fr 20px;
`;
